import { createSlice } from "@reduxjs/toolkit";
import { LOGOUT } from "../../../utils/constants";
import {
  refreshBuilder,
  logInBuilder,
  getInfoAboutAdminBuilder,
  getUsersForAdminBuilder,
  updateUserStatusBuilder,
  deleteUserBuilder,
  updateUserRoleBuilder,
} from "./builder";

const INIT_STATE = {
  admin: null,
  users: {
    data: [],
    page: 1,
    perPage: 10,
    total: 0,
    maxReached: false,
    error: null,
    loading: false,
  },
  userActions: {
    updating: {},
    deleting: {},
  },
  getInfoAboutAdminPending: false,
};

export const adminSlice = createSlice({
  name: "adminInfo",
  initialState: INIT_STATE,
  reducers: {
    resetState: () => INIT_STATE,
  },
  extraReducers: (builder) => {
    getInfoAboutAdminBuilder(builder);
    logInBuilder(builder);
    getUsersForAdminBuilder(builder);
    updateUserStatusBuilder(builder);
    deleteUserBuilder(builder);
    updateUserRoleBuilder(builder);
    refreshBuilder(builder);

    builder.addCase(LOGOUT, () => ({ ...INIT_STATE, user: undefined }));
  },
});

export const { resetState } = adminSlice.actions;

export const selectAdmin = (state) => state.adminInfo.admin;
export const selectUsers = (state) => state.adminInfo.users;
export const selectUserActions = (state) => state.adminInfo.userActions;

export default adminSlice.reducer;
